import multiMixin from 'privates/utils/multiMixin';
import * as members from 'privates/privateMembers';
import {SUPPORTED_STYLES} from 'privates/styleConstants';

/**
 * @namespace $w.Style
 * @summary An object representing an element's styles.
 */

class Style {
    constructor(RMI, compId, type, compNickname, styleMixins) {
        members._RMI.set(this, RMI);
        members._compId.set(this, compId);
        members._type.set(this, type);
        members._compNickname.set(this, compNickname);
        multiMixin(Style.prototype, styleMixins);
    }
}
/**
 * @class StyleMixin
 * @summary Provides functionality for elements that can be styled.
 * @memberof $w
 * @tagname styleMixin
 */
class StyleMixin {
    /**
     * @member style
     * @label property
     * @syntax
     * get style(): Style
     * @summary Gets an object containing information about the element's styles.
     * @snippet [BackgroundColorMixin-backgroundColor_set.es6=Set the background color]
     * @snippet [BackgroundColorMixin-backgroundColor_get.es6=Get the background color]
     * @type {$w.Style}
     * @memberof $w.StyleMixin
     * @readonly
     */
    get style() {
        let styleInstance = members._styleInstance.get(this);
        if (styleInstance) {
            return styleInstance;
        }

        const RMI = members._RMI.get(this);
        const compId = members._compId.get(this);
        const type = members._type.get(this);
        const styleMixins = SUPPORTED_STYLES[type.compType];
        const compNickname = this.id;

        styleInstance = new Style(RMI, compId, type, compNickname, styleMixins);
        members._styleInstance.set(this, styleInstance);
        return styleInstance;
    }
}

export default StyleMixin;



// WEBPACK FOOTER //
// ./js/modules/ui/mixins/styleMixins/StyleMixin.es6